<script>

    import { toast } from 'bulma-toast'
    import { userStore, usersStore, adminStore } from '../stores'
    import { isPermission } from '../$methods/permissions.methods'

    import UsersService from '../$services/users.service'

    import Icon from '../$components/icon.svelte'
    import Button from '../$components/button.svelte'
    import Form from '../$components/form.svelte'
    import SelectProviders from '../$components/select.providers.svelte'
    import Table from '../$components/table.svelte'

    let loading = false
    let providerSelected

    $: providers = $userStore?.providers || []
    $: canDelete = isPermission($adminStore, 'UsersView.Provider.Delete')
    $: skeletonCols = canDelete ? 2 : 1

    async function saveProviders(nextProviders) {

        loading = true
        const resp = await UsersService.updateUser($userStore._id, { providers: nextProviders })
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        userStore.set(resp.data)
        usersStore.replace(resp.data)
    }

    function filterProvider(provider) {
        saveProviders(providers.filter(item => item !== provider))
    }

    function addProvider() {
        if(!providerSelected) return
        saveProviders(Array.from(new Set([...providers, providerSelected])))
        providerSelected = ''
    }

</script>

<Table items={ providers.length } { loading } { skeletonCols }>
    <thead slot="thead">
        <tr>
            <th>
                <span class="icon-text">
                    <span class="icon"><i class="fas fa-truck"></i></span>
                    <span>Proveedor</span>
                </span>
            </th>
            {#if canDelete}
                <th>
                    <span class="icon-text">
                        <span class="icon"><i class="fas fa-ellipsis-v"></i></span>
                        <span>Acciones</span>
                    </span>
                </th>
            {/if}
        </tr>
    </thead>
    <tbody slot="tbody">
        {#each providers as provider}
            <tr>
                <td>{ provider }</td>
                {#if canDelete}
                    <td>
                        <div class="items-end">
                            <Icon on:click={() => filterProvider(provider)} icon="trash" />
                        </div>
                    </td>
                {/if}
            </tr>
        {/each}
    </tbody>
</Table>

{#if isPermission($adminStore, 'UsersView.Provider.Create')}
    <Form on:submit={addProvider} { loading }>
        <div class="items-space mt-4">
            <SelectProviders bind:provider={providerSelected} hideLabels />
            <Button type="submit" text="Agregar" icon="plus" />
        </div>
    </Form>
{/if}
